/**
 * ServiceIntro
 *
 * Centered intro section used directly below the hero on consulting service pages.
 * Features decorative circle SVGs on the left and right edges, a horizontal line
 * accent, a bold heading, and a short description paragraph.
 *
 * The left circle SVG is always the same. The right circle SVG varies per page
 * (e.g. different color per service) and is passed in as a prop.
 *
 * Props:
 * - title (string, required): The heading text. An orange period is appended automatically.
 * - description (string | ReactNode, required): The paragraph content. Supports JSX
 *                                               for inline elements like <strong>.
 * - rightCircleSrc (string, required): URL of the right decorative circle SVG.
 */

const ServiceIntro = ({ title, description, rightCircleSrc }) => {
  return (
    <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 my-16 lg:my-24 xl:my-52">
      <img
        src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/left-circle-group.svg"
        alt=""
        className="absolute hidden md:block md:-left-20 xl:-top-28 w-34 md:w-48 lg:w-56 xl:w-96"
      />
      <img
        src={rightCircleSrc}
        alt=""
        className="absolute hidden md:block -right-4 -top-16 md:-right-20 md:-top-8 lg:-top-36 xl:-top-80 xl:-right-64 w-32 md:w-48 lg:w-72 xl:w-[550px]"
      />
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center justify-center">
        <img
          src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/horizontal-line.svg"
          alt=""
          className="w-28 md:w-56 mx-auto mb-8 md:mb-12"
        />
        <h2 className="text-xl md:text-3xl md:px-32 xl:px-0 lg:text-4xl xl:text-6xl font-bold text-blue-dark1 mb-8 md:mb-12 text-center">
          {title}
        </h2>
        <p className="!text-sm md:!text-[22px] !font-medium !leading-[33px] text-center md:max-w-md lg:max-w-xl">
          {description}
        </p>
      </div>
    </section>
  );
};

export default ServiceIntro;
